import styled from 'styled-components';

export const Base = styled.div`
	width: 1px;
	height: 32px;
	background: ${({ theme }) => theme.gray[200]};
	margin: 0 4px;
`;

